var log = function log(...messages) {
  if (process.env.NODE_ENV === "development") {
    console.log(messages);
  }
};
exports.log = log;
